import { observer } from 'mobx-react';
import { CostBreakdownTooltip } from 'common/tooltips';
import React from 'react';

const CarrierServiceDeliveryDateAndRateOption = ({
	data: {
		extra,
		extra: {
			deliveryTimestamp,
			rateComposition: { cost, surcharge, total },
			carrier: { id },
		},
		value,
	},
}) => {
	return (
		<React.Fragment>
			{extra.carrier.surplusCharge != null && (
				<CostBreakdownTooltip
					idValue={value + id}
					shippingCost={cost}
					surplusCharge={surcharge}
					total={total}
					displayIcon={true}
				/>
			)}
			<span>{deliveryTimestamp}</span>
		</React.Fragment>
	);
};

export default observer(CarrierServiceDeliveryDateAndRateOption);



// WEBPACK FOOTER //
// ./src/core/components/select/options/CarrierServiceDeliveryDateAndRateOption.jsx